import React, {useRef} from 'react';
import Sticky from "react-stickynode";
import AppConfig from "../../../../../../../../../services/AppConfig";
import {ConfigApi, MenuProductViewType} from "../../../../../../../../../services/Api/types";
import {MultistoreMenuCategory, MultistoreMenuItem} from "../../../../../../../utils/types";
import MultistoreMenuCategoriesNavbar from "./Categories/MultistoreMenuCategoriesNavbar";
import StoreUtils from "../../../../../../../../../services/Store/StoreUtils";
import MultistoreMenuCategorySection from "./Categories/MultistoreMenuCategorySection";
import {useMainStickyNav} from "../../../../../../../../Contexts/MainNavStickyContext";
import MultistoreMenuTabs from "./Tabs/MultistoreMenuTabs";

interface Props {
    config: ConfigApi | undefined;
    menus: Record<string, any>[];
    menuId: number;
    categories: MultistoreMenuCategory[];
    setMenu: React.Dispatch<React.SetStateAction<Record<string, any> | undefined>>;
    setSelectedProduct: React.Dispatch<React.SetStateAction<MultistoreMenuItem | undefined>>;
}

const MultistoreMenu = ({menus, config, menuId, categories, setMenu, setSelectedProduct}: Props) => {
    const productsViewType = StoreUtils.getMenuProductsViewType(config);
    const {setMainNavSticky} = useMainStickyNav();
    const notStickyHeightRef = useRef<number | null>(null);

    const handleStickyStateChange = ({status}: Sticky.Status) => {
        const header = document.querySelector('.sticky-outer-wrapper') as HTMLElement;

        if (status === 2) {
            setMainNavSticky(false);

            if (header) {
                if (!notStickyHeightRef.current) {
                    notStickyHeightRef.current = header.clientHeight;
                }

                header.style.setProperty('height', `${notStickyHeightRef.current}px`, 'important');
            }
        } else {
            setMainNavSticky(true);
        }
    };

    return (
        <div className="menu">
            <div className="menu-container-with-gap">
                <div className="menu-container-with-gap">
                    <MultistoreMenuTabs menus={menus} menuId={menuId} setMenu={setMenu}/>
                    {categories.length > 1 && (
                        <Sticky top={0} bottomBoundary="#footer" innerZ={AppConfig.isWidget() ? 1019 : 1021}
                                activeClass="is-sticky"
                                onStateChange={handleStickyStateChange}>
                            <header
                                className="parent-top-nav sticky-fixed1 sticky-fixed-categories"
                                id="nav-scrollspy">
                                <MultistoreMenuCategoriesNavbar categories={categories} config={config}
                                                                menuId={menuId}/>
                            </header>
                        </Sticky>
                    )}
                </div>
                <div
                    className={`d-flex flex-column ${productsViewType === MenuProductViewType.HORIZONTAL ? "gap-4 mb-5" : ""}`}>
                    {categories.map((category) => (
                        <MultistoreMenuCategorySection
                            key={`${category.id}-${menuId}`}
                            productsViewType={productsViewType}
                            category={category}
                            itemOnClick={setSelectedProduct}
                            menuId={menuId}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default MultistoreMenu;